window.OBSWidgetConfig = {
  selector: "#obs-widget",
  settings: {
    locale: "de-DE",
    serviceUrl: "https://spamanager.de/booking/adameve/service/api",
    dppLink: "https://adameve-medical.com/policies/privacy-policy",
    conversionLink: null,
    treatmentsLayout: "accordion", // list, grid, accordion
    currencySymbol: "EUR",
    showPricing: false,
    showDuration: false,
    showEmployees: true,
    showNewCustomerOption: false,
        maxNumberOfTreatments: 5, // -1: unlimited
        enableDiscountCode: false, // Testcode 'TEST123'
        paypalClientId: null,
        affiliateId: null, // hier 'abc123ABC' eintragen oder an URL anhängen ?ref=abc123ABC
        maxParticipants: null, // treatmentId => { return maxNumberOfParticipants; },
    subsidiaryId: 2,
    requestParticipants: [], // IDs of treatments
    formConfig: {
      salutation: { show: true, required: false },
      firstName: { show: true, required: true },
      lastName: { show: true, required: true },
      birthday: { show: true, required: false },
      address: { show: true, required: false },
      postalCode: { show: true, required: false },
      city: { show: true, required: false },
      email: { show: true, required: true },
      phoneNumber: { show: true, required: true },
      memo: { show: true, required: false },
      terms: { show: true, required: true },
      acceptOffers: { show: true, required: false },
    },
    styling: {
      primaryColor: "#F4F3F0",
      widgetBackgroundColor: "transparent",
      textColor: "#303030",
      buttonBackgroundColor: "#ffffff",
      highlightTextColor: "#303030",
      borderColor: "#e1e1e1",
      borderRadius: "2px",
      borderWidth: "1px",
      fontFamily:
        '"Aptos", "Segoe UI", "Calibri", "Helvetica", "Arial", sans-serif',
      fontSize: "1em",
    },
  },
  tracking: {
    onStart: () => {},
    onSuccess: () => {
      gtag_report_conversion();
      console.debug("conversion reported");

      gtag("event", "buchung", {
        event_category: "Buchung",
        event_label: "Buchung Winterhude",
      });
    },
  },
};
